import { transformPhoneToDto } from '@http/service/shared-transformers'
import { SimplePersonFormModel } from '@shared/components/forms/shared/simple-person-form/model'

export const transformEstateAgentsFormToDto = (form: SimplePersonFormModel) => ({
	fullName: form.name,
	phone: transformPhoneToDto(form.phone),
	mail: form.email,
})
